import { FC } from 'react';
import { Modal } from 'react-bootstrap';

import DataTablePagination from 'modules/_shared/components/Tables/DataTablePagination';

import { useTranslate } from 'hooks/useTranslate';
import DividendDocumentTable from './DividendDocumentTable';
import { useDividendDocumentModal } from '../context/DividendDocumentModalContext';

const DividendDocumentModalBody: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useDividendDocumentModal();

  return (
    <Modal.Body style={{ minHeight: '652px' }}>
      <p>{t('SelectDividendsToGenerateDocument')}</p>

      <DividendDocumentTable />

      <DataTablePagination
        itemPerPage={data.rowsPerPage || 10}
        totalItems={data.totalPartners || 0}
        paginate={actions.handleChangePage}
        currentPage={data.currentPage}
        onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        customItemPerPage={0}
        setRowsPerPage={() => {}}
      />
    </Modal.Body>
  );
};

export default DividendDocumentModalBody;
